import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import '../styles/FormularioPublico.css';

console.log("API URL:", process.env.REACT_APP_API_URL);
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" }
});

export default function FormularioPublico() {

  const [form, setForm] = useState({

    // últimos 14 días
    fiebre: false,
    dolorGarganta: false,
    perdidaGusto: false,
    problemaRespiratorio: false,
    diarrea: false,
    cansancio: false,
    visionDoble: false,
    contactoSintomas: false,
    contactoCovid: false,
    diagnosticadoCovid: false,
    cuarentena: false,
    profesionRiesgo: false,

    // cardiovasculares
    hipertension: false,
    hipertensionTratamiento: "",
    cardiaca: false,
    cardiacaTratamiento: "",
    protesisValvular: false,
    marcapasos: false,
    fiebreReumatica: false,

    // hematológicas
    alteracionCoagulacion: false,
    alteracionCoagulacionTratamiento: "",
    anemia: false,

    // endocrinas
    diabetes: false,
    diabetesTratamiento: "",
    tiroides: false,

    // digestivas
    problemasEstomago: false,
    problemasHigado: false,

    //respiratorias
    insuficienciaRespiratoria: false,
    asma: false,
    tuberculosis: false,

    // renales  
    insuficienciaRenal: false,
    dialisis: false,
    trasplanteRenal: false,

    // otorrinológicas

    sinusitis: false,

    //infecciosas

    hepatitis: false,
    sida: false,
    herpes: false,

    // reumáticas
    artritis: false,
    artrosis: false,
    protesisArticular: false,
    osteoporosis: false,

    // neurológicas
    convulsiones: false,
    alteracionesMotoras: false,
    alteracionesCognitivas: false,
    tdahAutismo: false,

    // psiquiátricas
    depresion: false,
    ansiedad: false,
    esquizofrenia: false,

    // alergias
    alergiaMedicamentos: false,
    alergiaAlimentos: false,
    alergiaMetales: false,
    alergiaAmbiental: false,
    otrasAlergias: "",

    // habitos
    fuma: false,
    cuantoFuma: "",
    alcohol: false,
    sustancias: false,
    ejercicio: false,
    protectorBucal: false,
    embarazada: false,
    lactancia: false,

    medicacionActual: "",
    otrasObservaciones: "",

    // datos personales
    nombre: "",
    primerApellido: "",
    segundoApellido: "",
    nif: "",
    direccion: "",
    municipio: "",
    telefono: "",
    movil: "",
    email: "",
    fechaNacimiento: "",
    profesion: "",
    origen: "",
    incompatibilidades: "",
    alergias: "",
    historiaMedica: "",
    notasYComentarios: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const canvasRef = useRef(null);
  const dibujando = useRef(false);
  const [firmaValida, setFirmaValida] = useState(false);
  const [isStarted, setIsStarted] = useState(false);


  /* ==========================================
     LÓGICA DE BLOQUEOS Y SEGURIDAD
     ========================================== */
  useEffect(() => {
    if (!isStarted) return;

    // 1. Bloquear botón atrás
    const bloquearAtras = () => {
      window.history.pushState(null, "", window.location.href);
    };
    
    // 2. Bloquear teclado (F5, R, Backspace)
    const bloquearTeclas = (e) => {
      const tag = e.target.tagName?.toLowerCase();
      if (e.key === "Backspace" && tag !== "input" && tag !== "textarea") e.preventDefault();
      if (e.key === "F5") e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "r") e.preventDefault();
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", bloquearAtras);
    window.addEventListener("keydown", bloquearTeclas);

    return () => {
      window.removeEventListener("popstate", bloquearAtras);
      window.removeEventListener("keydown", bloquearTeclas);
    };
  }, [isStarted]);

  const iniciarProcesoSeguro = async () => {
    try {
      if (document.documentElement.requestFullscreen) {
        await document.documentElement.requestFullscreen();
      }
    } catch (e) {
      console.error("Fullscreen bloqueado", e);
    }
    setIsStarted(true);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const start = e => {
    dibujando.current = true;
    const rect = canvasRef.current.getBoundingClientRect();
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(
      (e.touches ? e.touches[0].clientX : e.clientX) - rect.left,
      (e.touches ? e.touches[0].clientY : e.clientY) - rect.top
    );
  };

  const draw = e => {
    if (!dibujando.current) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(
      (e.touches ? e.touches[0].clientX : e.clientX) - rect.left,
      (e.touches ? e.touches[0].clientY : e.clientY) - rect.top
    );
    ctx.stroke();
  };

  const end = () => {
    dibujando.current = false;
    setFirmaValida(true);
  };

  const limpiarFirma = () => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
  };

  const canvasVacio = () => {
    const blank = document.createElement("canvas");
    blank.width = canvasRef.current.width;
    blank.height = canvasRef.current.height;
    return canvasRef.current.toDataURL() === blank.toDataURL();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!canvasRef.current) return;

    // Verificar que no esté vacío
    const blank = document.createElement("canvas");
    blank.width = canvasRef.current.width;
    blank.height = canvasRef.current.height;

    if (canvasRef.current.toDataURL() === blank.toDataURL()) {
      alert("Debe firmar antes de enviar el formulario");
      return;
    }

    setLoading(true);

    try {
      const firmaBase64 = canvasRef.current.toDataURL("image/png");
      const payload = {...form, firma: firmaBase64};
      const res = await api.post("/public/formulario/crear", payload);
      const pdfUrl = `${process.env.REACT_APP_API_URL}${res.data}`;

      console.log("PDF URL:", pdfUrl);

      window.open(pdfUrl, "_blank");

      setSuccess(true);

    } catch (err) {
      alert("Error al enviar formulario");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="form-publico-success">
        <h2>✅ Datos enviados correctamente</h2>
        <p>Gracias. La clínica revisará su información.</p>
      </div>
    );
  }

  if (!isStarted) {
    return (
      <div className="flex flex-col items-center justify-center h-screen" style={{ textAlign: 'center', marginTop: '20%' }}>
        <h1>Historial Médico Clínica</h1>
        <button 
          onClick={iniciarProcesoSeguro}
          style={{ padding: '20px 40px', fontSize: '1.5rem', cursor: 'pointer', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '8px' }}
        >
          Empezar Formulario
        </button>
      </div>
    );
  }

  return (
    <div className="tablet-form-page">
      <h1>Formulario de Paciente</h1>

      <form onSubmit={handleSubmit}>

        <section className="bloque">
          <h3>Datos personales</h3>

          <div className="grid-2">
            <input name="nombre" placeholder="Nombre" onChange={handleChange} required />
            <input name="primerApellido" placeholder="Primer apellido" onChange={handleChange} required />
            <input name="segundoApellido" placeholder="Segundo apellido" onChange={handleChange} />
            <input name="nif" placeholder="DNI / NIF" onChange={handleChange} required />
            <input type="date" name="fechaNacimiento" onChange={handleChange} required />
            <input name="profesion" placeholder="Profesión" onChange={handleChange} />
          </div>
        </section>

        <section className="bloque">
          <h3>Contacto</h3>

          <div className="grid-2">
            <input name="telefono" placeholder="Teléfono" onChange={handleChange} />
            <input name="movil" placeholder="Móvil" onChange={handleChange} />
            <input name="email" placeholder="Email" onChange={handleChange} />
            <input name="direccion" placeholder="Dirección" onChange={handleChange} required />
            <input name="municipio" placeholder="Municipio" onChange={handleChange} required />
            <input name="origen" placeholder="¿Cómo nos conoció?" onChange={handleChange} />
          </div>
        </section>

        <section className="bloque">
          <h3>Últimos 14 días</h3>

          <div className="grid-checks">
            {[
              { key: "fiebre", label: "¿Ha tenido fiebre?" },
              { key: "dolorGarganta", label: "¿Ha tenido dolor de garganta?" },
              { key: "perdidaGusto", label: "¿Ha tenido pérdida del gusto o del olfato?" },
              { key: "problemaRespiratorio", label: "¿Ha tenido tos, fatiga o problemas respiratorios?" },
              { key: "diarrea", label: "¿Ha tenido diarrea o síntomas digestivos?" },
              { key: "cansancio", label: "¿Ha tenido sensación de mucho cansancio?" },
              { key: "visionDoble", label: "¿Ha tenido visión doble?" },
              { key: "contactoSintomas", label: "¿Contacto con persona con estos síntomas?" },
              { key: "contactoCovid", label: "¿Contacto con sospecha o confirmación COVID?" },
              { key: "diagnosticadoCovid", label: "¿Diagnóstico de COVID?" },
              { key: "cuarentena", label: "¿Sigue en cuarentena?" },
              { key: "profesionRiesgo", label: "¿Profesión de riesgo?" }
            ].map(item => (
              <label key={item.key} className="check-item">
                <input
                  type="checkbox"
                  checked={form[item.key]}
                  onChange={e => setForm({ ...form, [item.key]: e.target.checked })}
                />
                {item.label}
              </label>
            ))}
          </div>
        </section>

        <section className="bloque">
          <h3>Cardiovasculares</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.hipertension}
                onChange={e => setForm({ ...form, hipertension: e.target.checked })}
              />
              Hipertensión (tensión alta)
            </label>

            {form.hipertension && (
              <input
                className="input-tratamiento"
                value={form.hipertensionTratamiento}
                placeholder="Tratamiento"
                onChange={e => setForm({ ...form, hipertensionTratamiento: e.target.value })}
              />
            )}
          </div>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.cardiaca}
                onChange={e => setForm({ ...form, cardiaca: e.target.checked })}
              />
              Cardíacas (infarto, insuficiencia coronaria…)
            </label>

            {form.cardiaca && (
              <input
                className="input-tratamiento"
                value={form.cardiacaTratamiento}
                placeholder="Tratamiento"
                onChange={e => setForm({ ...form, cardiacaTratamiento: e.target.value })}
              />
            )}
          </div>

          <div className="grid-checks">
            <label>
              <input
                type="checkbox"
                checked={form.protesisValvular}
                onChange={e => setForm({ ...form, protesisValvular: e.target.checked })}
              />
              Prótesis valvular / stents
            </label>

            <label>
              <input
                type="checkbox"
                checked={form.marcapasos}
                onChange={e => setForm({ ...form, marcapasos: e.target.checked })}
              />
              Marcapasos
            </label>

            <label>
              <input
                type="checkbox"
                checked={form.fiebreReumatica}
                onChange={e => setForm({ ...form, fiebreReumatica: e.target.checked })}
              />
              Fiebre reumática
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Hematológicas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alteracionCoagulacion}
                onChange={e => setForm({ ...form, alteracionCoagulacion: e.target.checked })}
              />
              Alteración coagulación (antiagregantes, anticoagulados, hemorragias,...)
            </label>

            {form.alteracionCoagulacion && (
              <input
                className="input-tratamiento"
                value={form.alteracionCoagulacionTratamiento}
                placeholder="Tratamiento"
                onChange={e => setForm({ ...form, alteracionCoagulacionTratamiento: e.target.value })}
              />
            )}
          </div>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.anemia}
                onChange={e => setForm({ ...form, anemia: e.target.checked })}
              />
              Anemia
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Endocrinas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.diabetes}
                onChange={e => setForm({ ...form, diabetes: e.target.checked })}
              />
              Diabetes (azúcar en sangre)
            </label>

            {form.diabetes && (
              <input
                className="input-tratamiento"
                value={form.diabetesTratamiento}
                placeholder="Tratamiento"
                onChange={e => setForm({ ...form, diabetesTratamiento: e.target.value })}
              />
            )}
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.tiroides}
                onChange={e => setForm({ ...form, tiroides: e.target.checked })}
              />
              Tiroides (hipotiroidismo, hipertiroidismo)
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Digestivas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.problemasEstomago}
                onChange={e => setForm({ ...form, problemasEstomago: e.target.checked })}
              />
              Problemas de estómago (gastritis, hernia de hiato, úlcera,...)
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.problemasHigado}
                onChange={e => setForm({ ...form, problemasHigado: e.target.checked })}
              />
              Problemas de hígado (hepatitis, cirrosis, ictericia,...)
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Respiratorias</h3>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.insuficienciaRespiratoria}
                onChange={e => setForm({ ...form, insuficienciaRespiratoria: e.target.checked })}
              />
              Insuficiencia respiratoria
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.asma}
                onChange={e => setForm({ ...form, asma: e.target.checked })}
              />
              Asma
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.tuberculosis}
                onChange={e => setForm({ ...form, tuberculosis: e.target.checked })}
              />
              Tuberculosis
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Otorrinológicas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.sinusitis}
                onChange={e => setForm({ ...form, sinusitis: e.target.checked })}
              />
              Sinusitis
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Infecciosas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.hepatitis}
                onChange={e => setForm({ ...form, hepatitis: e.target.checked })}
              />
              Hepatitis
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.sida}
                onChange={e => setForm({ ...form, sida: e.target.checked })}
              />
              VIH/SIDA
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.tuberculosis}
                onChange={e => setForm({ ...form, tuberculosis: e.target.checked })}
              />
              Tuberculosis
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.herpes}
                onChange={e => setForm({ ...form, herpes: e.target.checked })}
              />
              Herpes
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Reumáticas</h3>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.artritis}
                onChange={e => setForm({ ...form, artritis: e.target.checked })}
              />
              Artritis
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.artrosis}
                onChange={e => setForm({ ...form, artrosis: e.target.checked })}
              />
              Artrosis
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.protesisArticular}
                onChange={e => setForm({ ...form, protesisArticular: e.target.checked })}
              />
              Prótesis articular
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.osteoporosis}
                onChange={e => setForm({ ...form, osteoporosis: e.target.checked })}
              />
              Osteoporosis
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Neurológicas</h3>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.convulsiones}
                onChange={e => setForm({ ...form, convulsiones: e.target.checked })}
              />
              Convulsiones / epilepsia
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alteracionesMotoras}
                onChange={e => setForm({ ...form, alteracionesMotoras: e.target.checked })}
              />
              Alteraciones motoras
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alteracionesCognitivas}
                onChange={e => setForm({ ...form, alteracionesCognitivas: e.target.checked })}
              />
              Alteraciones cognitivas
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.tdahAutismo}
                onChange={e => setForm({ ...form, tdahAutismo: e.target.checked })}
              />
              TDAH / Autismo
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Psiquiátricas</h3>

          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.depresion}
                onChange={e => setForm({ ...form, depresion: e.target.checked })}
              />
              Depresión
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.ansiedad}
                onChange={e => setForm({ ...form, ansiedad: e.target.checked })}
              />
              Ansiedad
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.esquizofrenia}
                onChange={e => setForm({ ...form, esquizofrenia: e.target.checked })}
              />
              Esquizofrenia
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Alergias</h3>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alergiaMedicamentos}
                onChange={e => setForm({ ...form, alergiaMedicamentos: e.target.checked })}
              />
              Alergia a medicamentos
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alergiaAlimentos}
                onChange={e => setForm({ ...form, alergiaAlimentos: e.target.checked })}
              />
              Alergia a alimentos
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alergiaMetales}
                onChange={e => setForm({ ...form, alergiaMetales: e.target.checked })}
              />
              Alergia a metales
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alergiaAmbiental}
                onChange={e => setForm({ ...form, alergiaAmbiental: e.target.checked })}
              />
              Alergia ambiental
            </label>
          </div>
          <div className="patologia">
            <input
              type="text"
              value={form.otrasAlergias}
              placeholder="Otras alergias"
              onChange={e => setForm({ ...form, otrasAlergias: e.target.value })}
            />
          </div>
        </section>

        <section className="bloque">
          <h3>Hábitos</h3>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.fuma}
                onChange={e => setForm({ ...form, fuma: e.target.checked })}
              />
              Fuma
            </label>
          </div>
          {form.fuma && (
            <input
              className="input-tratamiento"
              value={form.cuantoFuma}
              placeholder="¿Cuánto fuma?"
              onChange={e => setForm({ ...form, cuantoFuma: e.target.value })}
            />
          )}
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.alcohol}
                onChange={e => setForm({ ...form, alcohol: e.target.checked })}
              />
              Consumo de alcohol
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.sustancias}
                onChange={e => setForm({ ...form, sustancias: e.target.checked })}
              />
              Otras sustancias
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.ejercicio}
                onChange={e => setForm({ ...form, ejercicio: e.target.checked })}
              />
              Realiza ejercicio
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.protectorBucal}
                onChange={e => setForm({ ...form, protectorBucal: e.target.checked })}
              />
              Usa protector bucal
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.embarazada}
                onChange={e => setForm({ ...form, embarazada: e.target.checked })}
              />
              Embarazada
            </label>
          </div>
          <div className="patologia">
            <label>
              <input
                type="checkbox"
                checked={form.lactancia}
                onChange={e => setForm({ ...form, lactancia: e.target.checked })}
              />
              Lactancia
            </label>
          </div>
        </section>

        <section className="bloque">
          <h3>Medicación y observaciones</h3>

            <textarea
              value={form.medicacionActual}
              placeholder="Medicación actual"
              onChange={e => setForm({...form, medicacionActual: e.target.value})}
            />

            <textarea
              value={form.otrasObservaciones}
              placeholder="Otras observaciones"
              onChange={e => setForm({...form, otrasObservaciones: e.target.value})}
            />

        </section>

        <section>
          <h3>Firma del paciente</h3>
          <h1>Declaro que los datos facilitados en el presente documento son veraces y completos, y autorizo a
              la clínica al tratamiento de los mismos conforme a la normativa vigente.</h1>
          <canvas
            ref={canvasRef}
            width={700}
            height={200}
            style={{ border: "2px solid #000", touchAction: "none" }}
            onMouseDown={start}
            onMouseMove={draw}
            onMouseUp={end}
            onMouseLeave={end}
            onTouchStart={start}
            onTouchMove={draw}
            onTouchEnd={end}
          />
          <div className="firma-botones">
            <div style={{ marginTop: 10 }}>
              <button type="button" onClick={limpiarFirma}>
                Limpiar firma
              </button>
            </div>

            <button type="submit" disabled={!firmaValida || loading}>
              {loading ? "Enviando..." : "Enviar"}
            </button>
          </div>
        </section>

      </form>
    </div>
  );
}
